import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useWebSecurityStatusData } from '../../hooks/useWebSecurityStatusData';
import ServicesStatus from '../ServicesStatus/ServicesStatus';

export default memo(function WebSecurityStatus(props) {
    const [t] = useTranslation('dashboard');

    useWebSecurityStatusData(props.getWebSecurityStatusRequest);

    return <ServicesStatus
        description={t('dashboard:web_security_detail')}
        error={props.webSecurityStatus.error}
        fetching={props.webSecurityStatus.fetching}
        services={props.webSecurityStatus.status}
        title={t('dashboard:web_security')}
    />;
}, (prevProps, nextProps) =>
        prevProps.webSecurityStatus === nextProps.webSecurityStatus &&
        prevProps.getWebSecurityStatusRequest === nextProps.getWebSecurityStatusRequest
);
